import { CotationHistorique } from '@/model/cotation-historique';
import Axios from 'axios';
import { ApiUtils } from './api-utils';

export class CotationsApi {
  static getHistoriqueCotations (idArticle: number): Promise<CotationHistorique[]> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/articles/${idArticle}/historique-cotations`), [CotationHistorique]);
  }
}
